import { ReactNode } from "react"

import { Title, TitleContainerBox } from "./styles"

export const PageTitle = ({ children }: { children: ReactNode }) => {
  return (
    <TitleContainerBox>
      <Title variant="h1">{children}</Title>
    </TitleContainerBox>
  )
}
